// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-wapper-N_HQ9b,.select-wapper-N_HQ9b span{width:100%}.select-wapper-N_HQ9b .singleline-select-error-content{height:20px}.select-wapper-N_HQ9b .select-error-text{z-index:100;color:var(--coz-fg-hglt-red);padding-top:2px;padding-left:12px;font-size:12px;font-weight:400;position:absolute}.error-wapper-aGFHRP .semi-select{border:1px solid var(--coz-fg-hglt-red)!important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"select-wapper": `select-wapper-N_HQ9b`,
	"selectWapper": `select-wapper-N_HQ9b`,
	"error-wapper": `error-wapper-aGFHRP`,
	"errorWapper": `error-wapper-aGFHRP`
};
export default ___CSS_LOADER_EXPORT___;
